// Utils for OpenStreetMap API

/**
  * @param {number} Axis (0 -> lat, 1 -> lon)
  * @param {number} Latitude
  * @param {number} Longtitude
  * @param {number} Area offset of box around marker
  * @returns {number} Boundary box coordinate
  */
const getCoordOffset = (axis, lat, lon, offset) => {
  const radoff = axis === 0
    ? offset / 6378000 // 6378000 is earth radius in metres
    : offset / (6378000 * Math.cos(Math.PI * lat / 180))
  axis = axis === 0 ? lat : lon

  return axis + radoff * 180 / Math.PI
}

/**
  * @param {number} Latitude
  * @param {number} Longtitude
  * @param {number} Area of box around marker in kilometres
  * @returns {string} Boundary box string
  */
export const getBoundaryBox = (lat, lon, area) => {
  const offset = area / 2
  return `
  ${getCoordOffset(1, lat, lon, -offset)},
  ${getCoordOffset(0, lat, lon, -offset)},
  ${getCoordOffset(1, lat, lon, offset)},
  ${getCoordOffset(0, lat, lon, offset)}`
}



// WEBPACK FOOTER //
// ./src/utils/maps.js